import {
	createResource,
	type RouteResource,
	type RouteResourceResponse,
} from 'react-resource-router';

import type { MuteResponse, QuietHoursResponse } from '../../common/types';
import { getMuteDetail, getQuietHoursDetail } from '../endpoints';

// Redefined here since it is not exported from RRR.
type ResourceDependencies = {
	[type: string]: RouteResourceResponse;
};

const createMuteResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => boolean,
	depends?: string[],
): RouteResource<MuteResponse | null> =>
	createResource({
		type: 'muteResource',
		getKey: () => 'muteResource',
		getData: ({ dependencies, match }) => {
			const targetAccountId = match.params?.targetAccountId;
			const isConsolidated = checkConsolidationOnRouteDependency
				? // @ts-ignore - Type 'undefined' is not assignable to type 'RouteResourceResponse'.n
					// This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
					checkConsolidationOnRouteDependency(dependencies)
				: true;
			if (!isConsolidated) {
				return null;
			}
			return getMuteDetail(targetAccountId);
		},
		isBrowserOnly: true,
		depends,
	});

const createQuietHoursResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => boolean,
	depends?: string[],
): RouteResource<QuietHoursResponse | null> =>
	createResource({
		type: 'quietHoursResource',
		getKey: () => 'quietHoursResource',
		getData: ({ dependencies, match }) => {
			const targetAccountId = match.params?.targetAccountId;
			const isConsolidated = checkConsolidationOnRouteDependency
				? // @ts-ignore - Type 'undefined' is not assignable to type 'RouteResourceResponse'.
					// This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
					checkConsolidationOnRouteDependency(dependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}
			return getQuietHoursDetail(targetAccountId);
		},
		isBrowserOnly: true,
		depends,
	});

const muteResource: RouteResource<MuteResponse | null> = createMuteResource();
const quietHoursResource: RouteResource<QuietHoursResponse | null> = createQuietHoursResource();

export { createQuietHoursResource, createMuteResource, muteResource, quietHoursResource };
